/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';

const  requestUpdateTaskStatus =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.requestUpdateTaskStatus.url,
        maverickPortalApiEndPoint.requestUpdateTaskStatus.methodType,
        data
      )
      .then(response => {       
        const res = response.data;
        resolve({ res });
      });
  });
};

export { requestUpdateTaskStatus };
